document.documentElement.classList.add('scc-has-js');
document.addEventListener('DOMContentLoaded',()=>{
  const reveal=[...document.querySelectorAll('.scc-reveal')];
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    const io=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target);}});
    },{threshold:0.08,rootMargin:'0px 0px 35px 0px'});
    reveal.forEach(el=>io.observe(el));
  }else{reveal.forEach(el=>el.classList.add('is-visible'));}
  const stage=document.getElementById('sccGalleryMain');
  const thumbs=[...document.querySelectorAll('[data-scc-thumb]')];
  if(stage)thumbs.forEach(btn=>btn.addEventListener('click',()=>{
    const url=btn.getAttribute('data-url'),alt=btn.getAttribute('data-alt');
    if(!url)return;
    stage.src=url;stage.alt=alt||'Merry Climber product image';
    thumbs.forEach(b=>b.setAttribute('aria-pressed',b===btn?'true':'false'));
  }));
});